<p>
    Fantaknee Football is a satirical game about the news cycle. I was hired to
    develop it for a team commissioned by Super Deluxe.
</p>
